import { LOGIN_USER, LOGOUT } from "../constants/types";
export const login = (data) => ({
  type: LOGIN_USER,
  data: data,
});

export const logout = () => ({
  type: LOGOUT,
});
